import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: { paddingLeft: '22px', paddingRight: '20px' } }
const _hoisted_2 = { class: "flex items-center pt-4 pb-2 flex-row gap-6" }
const _hoisted_3 = { class: "flex items-center gap-4" }

import { PlusIcon } from "@heroicons/vue/24/outline";
import LiveSwitch from "@/components/live_video/LiveSwitch.vue";
import { Dashboard } from "@/types/Dashboard";
import DashboardMenu from "@/views/dashboard/componentsV2/DashboardMenu.vue";
import { useHasPermissionToEditDashboard } from "@/views/dashboard/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectOverviewV2Header',
  props: {
    currentDashboard: {},
    canEdit: { type: Boolean },
    dashboards: {}
  },
  emits: ["toggleAddWidgetSidebar", "selectDashboard", "showAddWidgetsSidebar", "resetCurrentDashboard"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const hasPermissionToEditDashboard = useHasPermissionToEditDashboard();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DashboardMenu, {
        canEdit: _ctx.canEdit,
        currentDashboard: _ctx.currentDashboard,
        dashboards: _ctx.dashboards,
        onSelectDashboard: _cache[0] || (_cache[0] = ($event: any) => (emit('selectDashboard', $event))),
        onShowAddWidgetsSidebar: _cache[1] || (_cache[1] = ($event: any) => (emit('showAddWidgetsSidebar', $event))),
        onResetCurrentDashboard: _cache[2] || (_cache[2] = ($event: any) => (emit('resetCurrentDashboard')))
      }, null, 8, ["canEdit", "currentDashboard", "dashboards"]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.canEdit && _ctx.currentDashboard && _unref(hasPermissionToEditDashboard)(_ctx.currentDashboard))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('toggleAddWidgetSidebar'))),
              class: "flex items-center gap-1 rounded bg-yellow-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-yellow-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600"
            }, [
              _createVNode(_unref(PlusIcon), { class: "h-5 w-5" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("dashboard.add_widget")), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode(LiveSwitch, { class: "" })
      ])
    ])
  ]))
}
}

})